<template>
  <div class="login">
    <div class="system-box">
      <!-- <div class="logo-img">
        <img src="@/assets/images/layout/img_logo_login.png" alt="">
      </div> -->
      <div class="bg-view">
        <img src="@/assets/images/layout/bg_login.png" alt="">
      </div>
      <div class="system-form">
        <el-form class="login-form" :model="form" :rules="rules" ref="form" label-width="0" size="medium">
          <div class="from-name-title">
            <img src="@/assets/images/layout/img_logo_login.png" alt="">
          </div>
          <el-form-item label="" prop="account">
            <el-input type="text" placeholder="电子邮箱" v-model="form.account" autocomplete="off" :disabled="isdis">
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" @keyup.enter.native="submitForm('form')" placeholder="密码" v-model="form.password" autocomplete="off" :disabled="isdis"></el-input>
          </el-form-item>
          <div class="login-tit">
            <div class="tip">请使用您的亿航工作邮箱进行登录</div>
            <el-checkbox-group v-model="checkList" class="remember-password">
              <el-checkbox label="记住密码"></el-checkbox>
            </el-checkbox-group>
          </div>
          <el-form-item class="login-btn">
            <wf-button type="primary" @click="submitForm('form')" :loading="loginLoading" :disabled="!form.account || !form.password" auto>登录</wf-button>
          </el-form-item>
          <div class="login-remember" @click="$router.push('/restPasswork')">
            <span>忘记密码了？</span>
          </div>
        </el-form>
      </div>
    </div>
    <div class="mobile-box">
      <el-popover placement="bottom" trigger="hover">
        <div class="mobile-box-img">
          <img v-if="isProduction" :src="'image/bar.png?production'" alt="">
          <img v-else src="image/test.png" alt="">
        </div>
        <div slot="reference">
          <i class="el-icon-mobile-phone"></i><span>移动版</span>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';
import { Cookie, codeMosaic, Encrypt3Des, Decrypt3Des, Storage } from '@/utils/utils';
import { mapActions } from "vuex";
let Base64 = require('js-base64').Base64
export default {
  data() {
    return {
      checkList: [],
      isdis: false,
      form: {
        account: '',
        password: '',
      },
      rules: {
      },
      loginLoading: false, // 登录中
      userMsg: '', // 用户信息
      isProduction: process.env.NODE_ENV === 'production'
    };
  },
  created() {
    if (Storage.get('loginInfo')) {
      const { checkList, email, username, password } = Storage.get('loginInfo');
      this.checkList = checkList || [];
      this.form.account = email || username;
      this.form.password = Decrypt3Des(password, "The Name For EhangWorkFlow", "admin");
    }
  },
  methods: {
    ...mapActions('layout/layout', ['login']),
    ...mapActions('permissions/permissions', ['permissionsIndex']),
    ...mapActions('customKey/customKey', ['deleteKey', 'getStandardComponents']),
    // 登录
    submitForm(formName) { // 普通登录
      const username = this.form.account;
      const password = this.form.password;
      this.$refs[formName].validate((valid) => {
        this.loginLoading = true;
        if (this.checkInput()) {
          const params = {
            email: username,
            password: Base64.encode(password),
          };
          this.login(params).then(async (data) => {
            this.userMsg = data
            if (this.checkList.length) {
              Storage.set("loginInfo", {
                checkList: this.checkList,
                username,
                password: Encrypt3Des(password, "The Name For EhangWorkFlow", "admin")
              });
            } else {
              Storage.set("loginInfo", {
                checkList: [],
                username,
                password: ""
              });
            }
            await this.permissionsIndex().then(res => { }).catch(err => { }) // 获取权限
            this.loginLoading = false;
            this.$router.push({
              path: '/'
            })
            this.getStandardComponents({ number: 999, page: 1 })
          }).catch((err) => {
            this.loginLoading = false;
          });
        }
      });
    },
    checkInput() {
      if (this.form.account.length === 0) {
        this.$message({
          message: '请输入用户名',
          type: 'error',
        });
        this.loginLoading = false;
        return false;
      }
      if (this.form.password.length === 0) {
        this.$message({
          message: '请输入密码',
          type: 'error',
        });
        this.loginLoading = false;
        return false;
      }
      return true;
    }
  },
};
</script>

<style lang="scss" rel="stylesheet/sass" src="./style.scss">
</style>



